import { supabase } from "@/integrations/supabase/client";

export function getAuthSession() {
  return supabase.auth.getSession();
}

export function updateUserPassword(password: string) {
  return supabase.auth.updateUser({ password });
}
